import clsx from 'clsx';
import { useUserModal, useActiveUser } from 'app/user'

import styles from './RegistrationReminder.module.scss'

export default ({ className, render }) => {
  const { openSignIn, openRegister, openVerify } = useUserModal();
  const activeUser = useActiveUser();
  const content = render({ activeUser, openSignIn, openVerify, openRegister });
  return content && (
    <div className={clsx(styles.register, className)}>
      { content }
    </div>
  )
}
